import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { Loader } from '../../components'
import { getSubscriptionDetails, subIsTeams, getSubscriptionTypeClasses } from './'
import SmsAutoRefillToggle from './SmsAutoRefillToggle'
import { path } from 'ramda'
import './SubscriptionSuccessMessage.less'

function SubscriptionSuccessMessage ({ user, subscription, currentDevice, appRefreshingUser, userActions }) {
  const details = getSubscriptionDetails(user, subscription, currentDevice)
  const shouldShowSmsToggle = !!path(['info', 'payments', 'defaultPaymentMethod'], user) && /awn-plus/.test(subscription)

  // Get subscription type classes for card styling
  const cardClasses = classNames(
    'subscription-success-message',
    'subscription-card',
    getSubscriptionTypeClasses({ productName: subscription })
  )

  // Only show loader if actively refreshing user data
  if (appRefreshingUser) {
    return (
      <div className={classNames(cardClasses, 'processing')}>
        <div className='card-header'>{details.displayName}</div>
        <div className='card-body'>
          <h2>Processing...</h2>
          <p>Your subscription is being activated. This may take a few moments.</p>
          <Loader />
        </div>
      </div>
    )
  }

  // Success state - this component only renders when paymentComplete is true
  return (
    <div className={classNames(cardClasses, 'success')}>
      <div className='card-header'>{details.displayName}</div>
      <div className='card-body'>
        <div className='checkmark-icon'></div>
        <h2>Thank you for subscribing!</h2>

        <div className='details'>
          {details.deviceInfo && (
            <div className='detail-row'>
              <span className='label'>Device:&nbsp;</span>
              <span className='value'>{details.deviceInfo.name}</span>
            </div>
          )}

          {details.renewalDate && (
            <div className='detail-row'>
              <span className='label'>{details.isScheduledChange ? 'Starts on:' : 'Renews:'}&nbsp;</span>
              <span className='value'>{moment(details.renewalDate).format('MMM D, YYYY')}</span>
            </div>
          )}

          <div className='detail-row'>
            <span className='value'>{details.displayPrice}</span>
          </div>

        </div>

        {shouldShowSmsToggle && !details.deviceInfo && (
          <div className='sms-toggle-container'>
            <SmsAutoRefillToggle user={user} userActions={userActions} />
          </div>
        )}

        <div className='btns text-center'>
          <Link to='/dashboard' className='btn btn-primary'>
            Dashboard
          </Link>
          <Link to='/subscriptions' >
            Manage Subscriptions
          </Link>
        </div>
      </div>
    </div>
  )
}

SubscriptionSuccessMessage.propTypes = {
  user: PropTypes.object.isRequired,
  subscription: PropTypes.string.isRequired,
  currentDevice: PropTypes.object, // Required for camera subscriptions, null for AWN+
  appRefreshingUser: PropTypes.bool,
  userActions: PropTypes.object.isRequired
}

SubscriptionSuccessMessage.defaultProps = {
  currentDevice: null,
  appRefreshingUser: false
}

SubscriptionSuccessMessage.displayName = 'SubscriptionSuccessMessage'

export default SubscriptionSuccessMessage
